/**
 * Line-oriented diff for prompt candidate review (PROMPT 8).
 * Marks lines in `next` that differ from `prev` at the same index or are new.
 */
export function diffPromptLines(prevText = "", nextText = "") {
  const prevLines = String(prevText).split("\n");
  const nextLines = String(nextText).split("\n");
  const maxLen = Math.max(prevLines.length, nextLines.length);

  const lines = [];
  for (let index = 0; index < maxLen; index += 1) {
    const prevLine = prevLines[index];
    const nextLine = nextLines[index];
    if (nextLine === undefined) continue;
    const changed =
      prevLine === undefined || prevLine !== nextLine;
    lines.push({ index: index + 1, text: nextLine, changed });
  }
  return lines;
}
